import React, { useState } from "react";
import {
  Box,
  Button,
  Stack,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Icon,
  ModalFooter,
  useToast,
  Select,
} from "@chakra-ui/react";
import {
  FaSync,
  FaPrint,
  FaPlus,
  FaImage,
  FaHeading,
  FaAlignLeft,
} from "react-icons/fa";
import axios from "axios";
import ListHouse from "./ListHouse";
import StudentDropdown from "./HouseDropdown";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../Globalapi/Globalapi";

function HouseCreation() {
  const toast = useToast();

  const [isHouseModalOpen, setIsHouseModalOpen] = useState(false);
  const [isLeaderModalOpen, setIsLeaderModalOpen] = useState(false); // State for leader modal
  const [houseCaption, setHouseCaption] = useState("");
  const [houseDescription, setHouseDescription] = useState("");
  const [houseImage, setHouseImage] = useState(null);

  const [leaderCaption, setLeaderCaption] = useState(""); // State for leader caption
  const [leaderRole, setLeaderRole] = useState(""); // State for leader role

  const openHouseModal = () => setIsHouseModalOpen(true);
  const closeHouseModal = () => setIsHouseModalOpen(false);

  const openLeaderModal = () => setIsLeaderModalOpen(true); // Open leader modal
  const closeLeaderModal = () => {
    setIsLeaderModalOpen(false);
    resetLeaderForm();
  };

  const resetLeaderForm = () => {
    setLeaderCaption("");
    setLeaderRole("");
  };

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  const handleSelectHouse = (selectedHouseId) => {
    console.log("Selected House ID:", selectedHouseId);
    // Handle the selected house ID as needed
  };
  const handleHouseSubmit = async () => {
    try {
      const houseData = {
        caption: houseCaption,
        description: houseDescription,
      };

      // Only include the image if it exists
      if (houseImage) {
        const imageBase64 = await getBase64(houseImage);
        houseData.image = imageBase64;
      }

      const response = await axios.post(
        `${BASE_URL}/admin/house/create_house.php`,
        houseData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("House created successfully:", response.data);
    } catch (error) {
      console.error("Error creating house:", error);
    }

    closeHouseModal();
  };

  const handleLeaderSubmit = async () => {
    try {
      const leaderData = {
        caption: leaderCaption,
        role: leaderRole,
      };

      const response = await axios.post(
        `${BASE_URL}/admin/house/create_house_captain.php`,
        leaderData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Leader assigned successfully:", response.data);
      toast({
        title: "Leader Assigned Successfully",
        description: "The leader has been assigned successfully.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error assigning leader:", error);
      toast({
        title: "Error Assigning Leader",
        description: "Error assigning leader: " + error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }

    closeLeaderModal();
  };

  return (
    <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
      <div className="teacher-list-container">
        <div className="header">
          <h1 style={{ fontSize: "20px", margin: 0 }}>House Creation</h1>
          <div className="action-buttons">
            {/* <Button
              onClick={() => window.location.reload()}
              boxShadow="md"
              backgroundColor="white"
              fontSize="11px"
            >
              <FaSync color="#515B73" />
            </Button> */}
            <Button
              backgroundColor="white"
              fontSize="11px"
              boxShadow="md"
              display={{ base: "none", md: "inline-flex" }} // Hide on mobile, show on larger screens
            >
              <FaPrint color="#515B73" />
              Print PDF
            </Button>
            <Button
              leftIcon={<FaPlus />}
              colorScheme="teal"
              onClick={openHouseModal}
            >
              <Box display={{ base: "none", md: "block" }}>House</Box>
            </Button>
          </div>
        </div>
        <div className="breadcrumb">
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>House</span> / <span>School House</span>
        </div>

        <ListHouse />
        {/* Include the HouseDropdown here */}
        <FormControl>
          <StudentDropdown onSelectHouse={handleSelectHouse} />
        </FormControl>
      </div>

      {/* Modal for House Creation */}
      <Modal
        isOpen={isHouseModalOpen}
        onClose={closeHouseModal}
        size="lg"
        motionPreset="slideInBottom"
      >
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          borderRadius="lg"
          boxShadow="xl"
          bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
          color="gray.700"
          p={6}
          maxW="700px"
          maxH="550px"
          overflowY="auto"
        >
          <ModalHeader
            fontSize="xl"
            fontWeight="bold"
            textAlign="center"
            color="teal.600"
          >
            <Icon as={FaPlus} boxSize={5} mr={2} />
            Add House Details
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody
            overflowY="auto"
            px={4}
            css={{
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-track": {
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "rgba(173, 216, 230, 0.6)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "rgba(173, 216, 230, 0.9)",
              },
            }}
          >
            <FormControl mt={4}>
              <FormLabel>
                {" "}
                <Icon as={FaImage} mr={1} color="teal.500" />
                House Image
              </FormLabel>
              <Input
                bg="white"
                _hover={{ borderColor: "teal.300" }}
                type="file"
                accept="image/*"
                onChange={(e) => setHouseImage(e.target.files[0])}
              />
            </FormControl>
            <FormControl isRequired>
              <FormLabel>
                {" "}
                <Icon as={FaHeading} mr={1} color="teal.500" />
                Caption
              </FormLabel>
              <Input
                name="caption"
                bg="white"
                _hover={{ borderColor: "teal.300" }}
                value={houseCaption}
                onChange={(e) => setHouseCaption(e.target.value)}
                placeholder="Enter house caption"
              />
            </FormControl>

            <FormControl mt={4}>
              <FormLabel>
                {" "}
                <Icon as={FaAlignLeft} mr={1} color="teal.500" />
                Description
              </FormLabel>
              <Textarea
                name="description"
                bg="white"
                _hover={{ borderColor: "teal.300" }}
                value={houseDescription}
                onChange={(e) => setHouseDescription(e.target.value)}
                placeholder="Enter house description"
              />
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button
              bgGradient="linear(to-r, teal.400, teal.600)"
              color="white"
              _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
              mr={3}
              onClick={handleHouseSubmit}
            >
              Save
            </Button>
            {/* <Button variant="ghost" onClick={closeHouseModal}>
              Cancel
            </Button> */}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
}

export default HouseCreation;
